import { render, staticRenderFns } from "./BaseDisplayText.vue?vue&type=template&id=29448bb2&scoped=true&"
import script from "./BaseDisplayText.vue?vue&type=script&lang=js&"
export * from "./BaseDisplayText.vue?vue&type=script&lang=js&"
import style0 from "./BaseDisplayText.vue?vue&type=style&index=0&id=29448bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29448bb2",
  null
  
)

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('BaseDisplayText', component.exports)
}
export default component.exports